// ──────────────────────────────────────────────────────────
// components/strategy/SignalRow.jsx
// ──────────────────────────────────────────────────────────

const STRATEGIES = {
  ORB_BREAKOUT: { label: "ORB 15-min", color: "#534AB7" },
  VWAP_SUPERTREND: { label: "VWAP + supertrend", color: "#0F6E56" },
  CPR_MEAN_REVERSION: { label: "CPR mean reversion", color: "#185FA5" },
  GAP_RS_MOMENTUM: { label: "Gap + RS", color: "#D85A30" },
  EMA_CROSS_VOLUME: { label: "EMA cross + vol", color: "#993556" },
  NR7_BREAKOUT: { label: "NR7 breakout", color: "#639922" },
};

const timeAgo = (iso) => {
  if (!iso) return "";
  const mins = (Date.now() - new Date(iso).getTime()) / 60000;
  if (mins < 1) return "just now";
  if (mins < 60) return `${Math.floor(mins)}m ago`;
  return `${Math.floor(mins / 60)}h ago`;
};

export default function SignalRow({ signal }) {
  const strat = STRATEGIES[signal.type] || {
    label: signal.type || "—",
    color: "#888",
  };
  const isLong = signal.direction === "BUY";
  const passed = signal.passed;

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 8,
        padding: "6px 10px",
        borderRadius: 6,
        border: "1px solid #e5e5e5",
        fontSize: 12,
        marginBottom: 4,
        opacity: passed ? 1 : 0.5,
        background: passed ? "#fff" : "#fafafa",
      }}
    >
      {/* Status dot */}
      <span
        style={{
          width: 5,
          height: 5,
          borderRadius: "50%",
          flexShrink: 0,
          background: passed ? "#0f6e56" : "#ccc",
        }}
      />

      {/* Strategy badge */}
      <span
        style={{
          fontSize: 10,
          fontWeight: 500,
          color: "#fff",
          padding: "1px 6px",
          borderRadius: 3,
          background: strat.color,
          flexShrink: 0,
        }}
      >
        {strat.label}
      </span>

      {/* Symbol */}
      <span
        style={{
          fontWeight: 500,
          color: "#111",
          minWidth: 65,
        }}
      >
        {signal.symbol}
      </span>

      {/* Direction */}
      <span
        style={{
          fontSize: 10,
          fontWeight: 500,
          padding: "0 5px",
          borderRadius: 3,
          background: isLong ? "#e1f5ee" : "#fcebeb",
          color: isLong ? "#0f6e56" : "#a32d2d",
        }}
      >
        {signal.direction}
      </span>

      {/* Price */}
      <span style={{ color: "#888" }}>@ {signal.price?.toFixed(2)}</span>

      {/* Status text */}
      <span style={{ marginLeft: "auto", color: "#aaa", fontSize: 11 }}>
        {passed
          ? "executed"
          : (signal.rejected_by || "skipped").replace(/_/g, " ").toLowerCase()}
      </span>

      {/* Time */}
      <span style={{ color: "#ccc", fontSize: 11 }}>
        {timeAgo(signal.timestamp)}
      </span>
    </div>
  );
}
